module.exports = __webpack_public_path__ + "img/16_18.76361c9e.png";